// extracted by mini-css-extract-plugin
module.exports = {"productForm__colors":"styles_productForm__colors__5bHG9"};